import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { ModifyTypeWizardEffects } from './effects';
import * as fromModifyTypeWizard from './reducer';

export function provideModifyTypeWizardStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(fromModifyTypeWizard.modifyTypeWizardFeatureKey, fromModifyTypeWizard.reducer),
    provideEffects(ModifyTypeWizardEffects),
  ]);
}
